import { render, staticRenderFns } from "./UILoader.vue?vue&type=template&id=002be3c0&functional=true&"
import script from "./UILoader.vue?vue&type=script&lang=js&"
export * from "./UILoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports